import React from 'react';
import { Check, CheckCheck, Clock, AlertCircle } from 'lucide-react';
import { MessageStatus } from '../../../types/models/whatsapp';

interface MessageStatusIconProps {
  status: MessageStatus;
  className?: string;
}

/**
 * Single source of truth for status iconography. Reused by the thread, the
 * conversation list, and broadcast recipient tables so a "read" tick means the
 * same thing everywhere.
 */
const MessageStatusIcon: React.FC<MessageStatusIconProps> = ({
  status,
  className = ''
}) => {
  const size = 'h-3.5 w-3.5';

  switch (status) {
    case 'queued':
      return (
        <Clock
          className={`${size} text-gray-400 ${className}`}
          aria-label="Queued"
        />
      );
    case 'sent':
      return (
        <Check className={`${size} text-gray-400 ${className}`} aria-label="Sent" />
      );
    case 'delivered':
      return (
        <CheckCheck
          className={`${size} text-gray-500 ${className}`}
          aria-label="Delivered"
        />
      );
    case 'read':
      return (
        <CheckCheck
          className={`${size} text-wa-tick ${className}`}
          aria-label="Read"
        />
      );
    case 'failed':
      return (
        <AlertCircle
          className={`${size} text-danger-600 ${className}`}
          aria-label="Failed"
        />
      );
    default:
      return null;
  }
};

export default MessageStatusIcon;
